import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { ActionsProps } from '@lib/components/ReactHookForm/FormContainer';

interface WidgetTemplateCreateActionsProps extends ActionsProps {
  onCancel: () => void;
  loading: boolean;
}

export default function WidgetTemplateCreateActions({
  onCancel,
  loading,
}: WidgetTemplateCreateActionsProps) {
  const { t } = useTranslation();

  return (
    <ActionsRow
      actions={[
        <Button
          key="cancel"
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          onClick={onCancel}
          leftIcon="close"
          fullWidth
          disabled={loading}
        />,
        <Button
          key="save"
          buttonText={t('save-template')}
          buttonType={ButtonTypes.primaryFilled}
          type="submit"
          leftIcon="check"
          fullWidth
          disabled={loading}
        />,
      ]}
    />
  );
}
